module.exports = __webpack_public_path__ + "img/close.0bca9393.svg";